/**
 * [BD feat] Smooth-scroll triggers via [data-bd-scroll-to].
 * Accepts a CSS selector, bare id, or bare class name.
 */
(function () {
  if (window.__bdScrollToBound) return;
  window.__bdScrollToBound = true;

  function findTarget(raw) {
    var value = String(raw || '').trim();
    if (!value) return null;

    var attempts = [value];
    if (value.charAt(0) !== '#' && value.charAt(0) !== '.' && value.indexOf('[') === -1) {
      attempts.push('#' + value, '.' + value);
    }

    for (var i = 0; i < attempts.length; i++) {
      try {
        var el = document.querySelector(attempts[i]);
        if (el) return el;
      } catch (err) {
        /* invalid selector — try next */
      }
    }
    return null;
  }

  function headerOffset() {
    var header =
      document.querySelector('page-header.page-header-sticky .page-header') ||
      document.querySelector('.page-header-sticky .page-header') ||
      document.querySelector('header.page-header') ||
      document.querySelector('#header');
    if (!header) return 0;
    return Math.ceil(header.getBoundingClientRect().height) || 0;
  }

  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-bd-scroll-to]');
      if (!trigger) return;

      var target = findTarget(trigger.getAttribute('data-bd-scroll-to'));
      if (!target) return;

      event.preventDefault();
      scrollToEl(target);
    },
    true
  );
})();
